import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, levels} from './answers'

const answers = justValues(levels)

export const Level = ({givenName}) => {
  const {submitAnswers} = useOutletContext()
  return (
    <div className="column">
      <div className="heading size-xxxl">
        It's all about you <em>{givenName}</em>
      </div>
      <section className="intro">
        <div className="content size-l">
          To help create a personalised experience and get
          the most from the app, we'd like to learn more about you.
        </div>
      </section>
      <section className="question">
        <div className="content size-xl">I'd consider myself...</div>
      </section>
      <section className="answers">
        <div className="content">
          {answers.map(it => (
            <Button size="large" action={() => submitAnswers([it])} key={it}>
              {it}
            </Button>
          ))}
        </div>
      </section>
    </div>
  )
}
